// extracted by mini-css-extract-plugin
export var container = "_404-module--container--66e24";
export var heading = "_404-module--heading--4842b";
export var tagline = "_404-module--tagline--4f37c";